import { useMgPrisConfig } from '@retail/app/stores/app-config';
import { useAuthContext } from '@retail/auth/data-access';
import { ItemAgreementDTO } from '@retail/purchase-agreements/types';
import { QueryOptions } from '@shared/fetch-utils';
import { buildUrl } from '@shared/utils';
import { useMPEFetch } from '@retail/app/hooks';
import { mpeApi } from '@retail/mgpris/config';

interface Props extends QueryOptions {
  assortmentId: number;
  supplierItemId: number;
}

export function useFetchAgreementPricesForItem({
  assortmentId,
  supplierItemId,
  ...queryOptions
}: Props) {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();

  return useMPEFetch<ItemAgreementDTO[]>({
    method: 'GET',
    queryKey: ['item-agreement-prices', assortmentId, supplierItemId],
    token,
    url: buildUrl({
      base: mpe.url,
      route: mpeApi.mgSupplierItems.supplierItem.agreementPrices.getFullLinkPath({
        supplierItemId,
      }),
      searchParams: { assortmentId },
    }),
    ...queryOptions,
  });
}
